export default __webpack_public_path__ + "static/media/seciton3_icon.2b48cbdc.svg";